import React from 'react';
import { observer } from 'mobx-react';
import NewAssessmentDetails from '../components/PerformanceReviews/NewAssessmentDetails';
import {
    Card,
    CardContent,
    CardHeader,
} from 'semantic-ui-react';

const MyAssessmentsReportPage = ({ assessmentsStore, usersStore, companyStore }) => {
    const handleSaveToLibrary = companyStore ? async (questionsToSave) => {
        const existing = companyStore.company.questionsAndAnswers.map(qa => ({
            question: qa.question,
            answer: qa.answer,
            related_to: qa.related_to,
            ...(qa.uploadKey ? { uploadKey: qa.uploadKey } : {})
        }));
        const newQuestions = questionsToSave.filter(q =>
            !existing.some(eq => eq.question?.trim() === q.question?.trim())
        );
        if (newQuestions.length === 0) return;
        await companyStore.company.updateQuestionsAndAnswers([...existing, ...newQuestions]);
    } : undefined;

    return <div>
        <h1 style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '1.5rem', fontWeight: 700, color: '#1a1a2e', margin: '0 0 16px 0' }}>My Performance Reports</h1>
        <Card fluid>
            <CardContent>
                <CardHeader>Assessments</CardHeader>
            </CardContent>
            <CardContent style={{ padding: 0 }}>
                <NewAssessmentDetails
                    assessments={assessmentsStore.closedAssessmentsForUser(usersStore.currentUser.userId, companyStore?.company?.id)}
                    canEditLibrary={!usersStore.currentUser.isSalesMember && !usersStore.currentUser.isReadOnlyExecutive && !usersStore.currentUser.isReadOnlySalesManager && !usersStore.currentUser.isReadOnlySeniorManager}
                    existingQuestions={companyStore ? companyStore.company.questionsAndAnswers || [] : []}
                    onSaveToLibrary={handleSaveToLibrary}
                />
            </CardContent>
        </Card>
    </div>;


};

export default observer(MyAssessmentsReportPage);